import { useTranslation } from "react-i18next";
import { useState } from "react";
import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import { Box, Stack, styled, Typography } from "~/common/mui";

interface Props {
  className?: string;
  url: string;
}

const Iframe = styled("iframe")({
  border: "none",
  width: "100%",
  height: 400,
});

export const MarketingCloudProfileCenterIframe = ({ url, className }: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  return (
    <Stack sx={{ gap: 4, position: "relative" }} className={className}>
      <Typography variant="headlineSmall" sx={{ m: 0, ...(loading && { opacity: 0 }) }}>
        {t("myAccount.mcProfileCenter.title")}
      </Typography>
      <Iframe src={url} sx={{ ...(loading && { opacity: 0 }) }} onLoad={() => setLoading(false)} />
      {loading && (
        <Box sx={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <CircleSpinner />
        </Box>
      )}
    </Stack>
  );
};
